export default from './PartiesCases';



// WEBPACK FOOTER //
// ./src/components/case/parties/index.js